import React from 'react';
import PropTypes from 'prop-types';
import { PROGRAM_NAMES } from '@/shared/utils/deadline';
import { PROGRAM_DISPLAY_ORDER } from '@/shared/utils/programOrder';
import { PROGRAM_PAGE_URLS } from '@/shared/utils/programInfo';

/** A link to each program's official MSU Denver page, in display order. */
function ProgramPageLinks({ className = '' }) {
    return (
        <ul className={className}>
            {PROGRAM_DISPLAY_ORDER.map((programType) => (
                <li key={programType}>
                    <a
                        href={PROGRAM_PAGE_URLS[programType]}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {PROGRAM_NAMES[programType]} program page
                        <span className="visually-hidden">
                            {' '}
                            (opens in a new tab)
                        </span>
                    </a>
                </li>
            ))}
        </ul>
    );
}

ProgramPageLinks.propTypes = {
    className: PropTypes.string,
};

/**
 * What a student sees wherever the Hub would otherwise invite them to apply
 * for a peer support position, while the studentApplication feature is off.
 */
export function StudentApplicationsNotOpen({ className = '' }) {
    return (
        <div className={className}>
            <p className="mb-2">
                Applications to become a peer supporter are not open through the
                Peer Support Hub yet. Visit each program&apos;s page to learn
                how to apply:
            </p>
            <ProgramPageLinks className="mb-0" />
        </div>
    );
}

StudentApplicationsNotOpen.propTypes = {
    className: PropTypes.string,
};

export default ProgramPageLinks;
